<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Group By</h5>

    <GroupedOptions
      @input="(value) => $emit('input', value)"
      :value="value"
      :options="options"
      native-type="radio"
      button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
    />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import GroupedOptions from '@components/GroupedOptions'

export default defineComponent({
  name: 'SaveReportWizardGroupByBroker',
  components: {
    GroupedOptions
  },
  emits: ['input'],
  props: {
    value: {
      type: String,
      default: 'None'
    }
  },
  setup() {
    const options = ['None', 'Underwriter', 'Broker', 'Coverholder'].map(
      (value) => ({
        value: 'None' == value ? '' : value,
        label: value
      })
    )

    return {
      options
    }
  }
})
</script>
